import React, { ComponentType, FC, useCallback } from 'react';
import { useNavigation } from 'react-day-picker-for-new-calendar';
import { addMonths } from 'date-fns';
import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material';

import {
    ChevronsLeft24,
    ArrowLeft24,
    ArrowRight24,
    ChevronsRight24,
} from '../../../icons';
import { Stack } from '../../Stack';


type NavButtonIcon = IconButtonProps & {
    icon: ComponentType<SvgIconProps>;
};

const NavButton: FC<NavButtonIcon> = ({ icon: Icon, sx = {}, ...props }) => (
    <IconButton
        sx={{
            p: 1,
            borderRadius: ({ spacing }) => spacing(2.5),
            color: 'grayscale.shade95',
            backgroundColor: 'grayscale.shade10',
            ...sx,
        }}
        {...props}
    >
        <Icon
            sx={({ spacing }) => ({ width: spacing(4), height: spacing(4) })}
        />
    </IconButton>
);

export const Navbar: FC = () => {
    const { currentMonth, goToMonth } = useNavigation();
    const onChangeMonth = useCallback(
        (amount: number) => goToMonth(addMonths(currentMonth, amount)),
        [currentMonth, goToMonth],
    );

    return (
        <Stack direction='row' width='100%' alignItems='center' height={({ spacing }) => spacing(8)}>
            <NavButton
                onClick={useCallback(() => onChangeMonth(-12), [onChangeMonth])}
                icon={ChevronsLeft24}
            />
            <NavButton
                onClick={useCallback(() => onChangeMonth(-1), [onChangeMonth])}
                icon={ArrowLeft24}
                sx={{ mr: 'auto', ml: 2 }}
            />
            <NavButton
                onClick={useCallback(() => onChangeMonth(1), [onChangeMonth])}
                icon={ArrowRight24}
                sx={{ ml: 'auto', mr: 2 }}
            />
            <NavButton
                onClick={useCallback(() => onChangeMonth(12), [onChangeMonth])}
                icon={ChevronsRight24}
            />
        </Stack>
    );
};
